import { memo } from 'react';

import TransformedHtmlCore from './TransformedHtmlCore';

export const TransformedHtml = memo(TransformedHtmlCore, (prev, next) => {
  return prev.slug === next.slug && prev.update === next.update;
});
